import { ApiQueryKey } from '@/configs/ApiQueryKey';
import EntityApi, { BaseEntity } from './EntityApi';
import { ApiPaginatedResponse, UUID } from '@/types/types';
import httpClient from './httpClient';
import { Client } from '@/types/users';
import { ProductType } from './ProductTypeApi';
import { FormAnswer, FormStatus, QuantityPerDimension } from './FormApi';

export enum OrderStatus {
	NEW = 'NEW',
	IN_PROGRESS = 'IN_PROGRESS',
	READY = 'READY',
	COMPLETED = 'COMPLETED',
	CANCELLED = 'CANCELLED',
}

export interface UserForm extends BaseEntity {
	orderId: string;
	productType: ProductType;
	userData: {
		name: string;
		companyName: string;
		NIP: string;
		city: string;
		postalCode: string;
		address: string;
		email: string;
		phone: string;
	};
	shippingData: {
		city: string;
		postalCode: string;
		address: string;
	};
	user: Client;
	quantity: number;
	orderDate: string;
	note: string;
	formAnswers: FormAnswer[];
	quantityPerDimension: QuantityPerDimension[];
	createdAt: string;
	status: FormStatus;
	externalOrderID: string;
}

export interface Order extends BaseEntity {
	id: UUID;
	orderNumber: string;
	externalId?: string;
	client: Client;
	productType: string;
	status: OrderStatus;
	createdAt: string;
}

export interface OrdersQueryParams {
	search?: string;
	orderNumber?: string;
	externalId?: string;
	clientId?: string;
	productType?: string;
	status?: OrderStatus;
	page?: number;
	limit?: number;
	pageSize?: number;
	sort?: {
		key: keyof Order;
		order: 'ASC' | 'DESC';
	};
}

class OrdersApi extends EntityApi<UserForm> {
	constructor() {
		super(ApiQueryKey.orders);
	}
}

export default new OrdersApi();
